const translate_pricing = [
    {
        id:0,
        text:"UpayS integrates STRIPE payment service"
    }
]
const translate_docs= [
    {
        id:0,
        text:'UpayS service accelerates the development process of a web projects that use STRIPE payment service,'
    },
    {
        id:1,
        text:''
    }
]
const translate_footer = [
    {
        id:0,
        text:'Privacy,Terms,FAQ,24/7,We act as a proxy,' +
            'the STRIPE API KEY is used securely and never stored by us.,' +
            'SIMPLE & EASY micro-service by'
    },
    {
        id:1,
        text:'Privacy,Terms,FAQ,24/7,我們充當代理人,' +
            'Stripe API 金鑰使用安全，我們絕對不會儲存該金鑰。,' +
            '簡單易用的微服務'
    }
]
const translate_menu = [
    {
        id:0,
        menu:'30-dayFree,SignIn,LogOut,Pricing'
    },
    {
        id:1,
        menu:'30天免費試用,登入,退出,定價'
    }
]
const left_panel = [
    {
        id:0,
        messages:'Simple programming skills are required for integration,' +
            'Connect your webapp/website to STRIPE in 5 minutes,' +
            'Integrate your app customer authentication process in minutes,' +
            'Payment microservice * free 24/7 support'
    },
    {
        id:1,
        messages: '整合需要基本的程式設計技能。,' +
            '5分鐘內將您的Web應用程式/網站連接到 STRIPE,' +
            '幾分鐘內即可整合您的應用程式客戶身份驗證流程,' +
            '支付微服務 * 免費全天候支持'
    }
]
const right_panel = [
    {
        id:0,
        messages:'How to use,1. Pay lifetime fee & get Access Key,credits,' +
            '2. Configure the Pay Page [B2B/B2C],' +
            '3. Generate the PAYLink that displays your Pay Page,' +
            '4. Customize PAYLink with pay unit and your app\'s STRIPE Key,' +
            '5. Attach the PAYLink to a "Pay" button,' +
            '7. Check Your STRIPE account for sales, Pay the fee,' +  // Let's start
            '6. Test now Pay Page connected to your STRIPE Account,' +
            ' - Quickly integrates into web apps/sites, Use License Key '
    },
    {
        id:1,
        messages: '如何使用？,' +
            '1. 支付終身費用即可獲得存取密鑰,學分, ' +
            '2. 配置支付頁面 [企業對企業 / 企業對消費者],' +
            '3. 產生顯示您的付款頁面的 PAYLink,' +
            '4. 使用支付單位和應用程式的 Stripe Key 自訂 PAYLink,' +
            '5. 將 PAYLink 附加到「付款」按鈕,' +
            '7. 檢查您的 STRIPE 帳戶的銷售情況, 繳費,' +
            '6. 立即測試與您的 STRIPE 帳戶連結的付款頁面,' +
            '—快速整合到應用程式中,使用許可證密鑰'
    }
]
const reqTrial =[
    {
        id:0,
        lines:'The app will generate a PAYLink and an Access Key [ to signIn ],' +
            'PAYLink will display a Pay Page [ using STRIPE ] that your App/Business can use.' +
            'The Pay Page isn\'t configurable,Your Access Key,Hide,' +
            'keep it in a safe place,Pay Page ,Business2Business & Monthly payment,Preview Pay Page,' +
            'Enter the web link of your App/Business, where the customer should be redirected after completing / cancelling the payment ,' +
            'PAYLink,Hide PAYLink,[ TEST mode ] PAYLink contains pay unit,' +
            'test,[ PROD mode ] Replace values of,pay unit,with your app values,' +
            'Update,Generate SHA256 keys for your customers,Display,if your app/business requires an authentication process,' +
            'Keep it local, Exit, Dashboard'
    },
    {
        id:1,
        lines:'該應用程式將產生一個 PAYLink 和一個存取金鑰 [ 用於登入 ],PAYLink 將顯示您的應用程式/企業可以使用的付款頁面 [使用 STRIPE].' +
            '試用付款頁面不可配置,您的存取密鑰,隱藏,將其保存在安全的地方,' +
            '付款頁面配置為,商業對商業和每月付款,預覽您的付款頁面,輸入您的應用程式/業務鏈接,付款完成後重定向到哪裡,PAYLink,隱藏 PAYLink,' +
            '[測試模式] PAYLink包含支付單位,測試,[ PROD 模式 ] 替換值,支付單位,符合您的應用價值觀,更新,為客戶產生 SHA256 金鑰,展示,' +
            '如果您的應用程式/業務需要付款後進行身份驗證流程,保持本地化,出口,儀表板'
    }
]
const signin = [
    {
        id:0,
        info:'Type Your Access Key...,Sign In'
    },
    {
        id:1,
        info:'輸入您的存取密鑰...,登入',
    }
]
const payForm = [
    {
        id:0,
        fields:'Connected to,STRIPE,Name,Enter Name,Registration Number,Address,Billing Address,VAT Id,E-mail,Months,' +
            'Currency, By providing your Card Number and confirming this payment you are' +
            ' authorizing STRIPE - the payment service ' +
            ' provider to send instructions to your bank to debit your account.,Pay,Cancel,Invoice Required fields,' +
            'Privacy Policy,The entered data is used only for generating invoices'
    },
    {
        id:1,
        fields:'連接到,Stripe,姓名,輸入姓名,註冊號,地址,帳單地址,增值稅號,電子郵件,幾個月,貨幣,透過提供您的卡片號並確認此付款，' +
            '透過提供您的卡號並確認此付款，您即授權 STRIPE（支付服務提供者）向您的銀行發送指示以從您的帳戶中扣款。,支付,取消,發票必填字段,' +
            '隱私權政策,輸入的資料僅用於產生發票。'
    }
]
const pageConfig = [
    {
        id:0,
        lines:'Your Access Key,Hide Access Key,keep it in a safe place,Dashboard,update,' +
            'Page Scope,Business 2 Client,Business 2 Business,Payment type,Monthly Fee,One Time Fee,' +
            'Preview Pay Page,Enter the web link of your App/Business,' +
            'PAYLink,Hide PAYLink,[ PROD mode ] Replace values of,pay unit,' +
            'with your app values,[ TEST mode ] PAYLink contains pay unit,test,' +
            'Generate SHA256 keys for your customers,Display,if your app/business requires an authentication process,' +
            'Does payment create a customer on the STRIPE platform?, Exit, Keep it local,where the customer should be redirected after completing / cancelling the payment'
    },
    {
        id:1,
        lines: '您的存取密鑰,隱藏存取金鑰,將其保存在安全的地方,您的儀表板,更新,頁面範圍,商務2客戶,' +
            '商務2 商務,支付方式,月費,一次性費用,預覽您的付款頁面,輸入您的企業 Web 鏈接，付款完成後重定向至何處,' +
            'PAYLink,隱藏 PAYLink,[ PROD 模式 ] 替換值,支付單位,符合您的應用價值觀,[測試模式] PAYLink包含支付單位,測試,' +
            '為您的客戶產生 SHA256 金鑰,展示,如果您的應用程式/業務需要付款後進行身份驗證流程,' +
            '付款是否會在 STRIPE 平台上建立客戶?,出口, 保持本地化,客戶完成/取消付款後應被重定向到哪裡。'
    }
]

export function getPageConfig(id) {
    return pageConfig[id].lines.split(',')
}
export  function getPayFormFields(id){
    return payForm[id].fields.split(',')
}
export function getSignInInfo(id){
    return signin[id].info.split(',')
}
export function getTrialLines(id){
    return reqTrial[id].lines.split(',')
}
export function getRightPanelMessages(id){
    return right_panel[id].messages.split(',')
}
export function getLeftPanelMessages(id){
    return left_panel[id].messages.split(',')
}
export function getMenu(id) {
    return translate_menu[id].menu.split(',')
}
export function getDocsText(id){
    return translate_docs[id].text.split(',')
}
export function getPricingText(id){
    return translate_pricing[id].text.split(',')
}
export function getFooterText(id){
    return translate_footer[id].text.split(',')
}